import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useClienteAuth } from '../contexts/ClienteAuthContext';
import { Loading } from './ui';

/**
 * Protege as rotas da área do cliente da loja (/loja/conta).
 * Redireciona para o login do cliente quando não autenticado.
 */
export function ProtectedContaRoute({ children }: { children: ReactNode }) {
  const { logado, carregando } = useClienteAuth();
  const location = useLocation();

  if (carregando) {
    return (
      <div className="min-h-screen bg-ink-50 flex items-center justify-center">
        <Loading altura="h-32" />
      </div>
    );
  }

  if (!logado) {
    return <Navigate to="/loja/conta/login" state={{ de: location.pathname }} replace />;
  }

  return <>{children}</>;
}
